import { UserType } from "../types/userType";

export const users: UserType[] = [
  {
    id: 1,
    name: "Felecia Rower",
    avatar: "./users/user1.jpg",
    lastMsg: "Hello, how are you?",
    unSeen: 2,
    profession: "Project Manager",
    bio: "I'm Felecia Rower, and I recently graduated with an advanced diploma from Smith secondary school. I'm seeking an internship where I can apply my skills in content creation and increase my experience in digital marketing.",
    isActive: true,
  },
  {
    id: 2,
    name: "Verla Morgano",
    avatar: "./users/user2.jpg",
    lastMsg: "Hello, how are you?",
    unSeen: 1,
    profession: "Cheif Executive Officer",
    bio: "I'm Verla Morgano, and I recently graduated with an advanced diploma from Smith secondary school. I'm seeking an internship where I can apply my skills in content creation and increase my experience in digital marketing.",
    isActive: true,
  },
  {
    id: 3,
    name: "Sal Piggee",
    avatar: "./users/user3.jpg",
    lastMsg: "Hello, how are you?",
    unSeen: 0,
    profession: "Cheif Technology Officer",
    bio: "I'm Sal Piggee, and I recently graduated with an advanced diploma from Smith secondary school. I'm seeking an internship where I can apply my skills in content creation and increase my experience in digital marketing.",
    isActive: false,
  },
  {
    id: 4,
    name: "Miguel Guelff",
    avatar: "./users/user4.jpg",
    lastMsg: "Hello, how are you?",
    unSeen: 0,
    bio: "I'm Miguel Guelff, and I recently graduated with an advanced diploma from Smith secondary school. I'm seeking an internship where I can apply my skills in content creation and increase my experience in digital marketing.",
    profession: "Team Leader",
    isActive: false,
  },
  {
    id: 5,
    name: "Bridgett Omohundro",
    avatar: "./users/user5.jpg",
    lastMsg: "Hello, how are you?",
    unSeen: 0,
    bio: "I'm Bridgett Omohundro, and I recently graduated with an advanced diploma from Smith secondary school. I'm seeking an internship where I can apply my skills in content creation and increase my experience in digital marketing.",
    profession: "Team Leader",
    isActive: false,
  },
  {
    id: 6,
    name: "Margot Henchke",
    avatar: "./users/user6.jpg",
    lastMsg: "Hello, how are you?",
    unSeen: 0,
    bio: "I'm Margot Henchke, and I recently graduated with an advanced diploma from Smith secondary school. I'm seeking an internship where I can apply my skills in content creation and increase my experience in digital marketing.",
    profession: "Managing Director",
    isActive: false,
  },
];
